import React from 'react';
import 'react-dropdown/style.css';
import {useTranslation} from 'react-i18next';

import HeaderLogo from '../../blocks/logo/HeaderLogo';
import MenuModal from '../../components/modal/MenuModal';

import Languages from '../language/languages';
import {HOST} from "../../settings";

const Header = ({logoColor = 'dark', logoVariant = 'default'}) => {
  const {t} = useTranslation();

  return (
    <header id="header" className="site-header">
      <div className="wrapper">
        <div className="header-contact-links-mobile">
          <a href="tel:+494037088807" className="header-contact-link">
            (040) 370 888 07
          </a>
          <a href="mailto:info@hanse-euroderm.de" className="header-contact-link">
            info@hanse-euroderm.de
          </a>
        </div>
        <div className="header-content d-flex justify-content-between">
          <div className="header-left align-self-center">
            <div className="links">
              <div className="links-items">
                <div className="links-item">
                  <a href={HOST.PUBLIC_URL + '/'}
                     className="btn btn-lg btn-before-dot btn-link border-0 p-0 min-w-auto">{t(
                    'main_page.menu_home')}</a>
                </div>
              </div>
            </div>
            <div className='languages-left'>
              <Languages color={logoColor}/>
            </div>
          </div>

          <div className="header-center align-self-center">
            <HeaderLogo logoColor={logoColor} variant={logoVariant}/>
          </div>

          <div className="header-right d-flex justify-content-end">
            <div className="d-flex align-items-center">
              <div className="header-contact-links">
                <a href="tel:+494037088807" className="header-contact-link">
                  (040) 370 888 07
                </a>
                <a href="mailto:info@hanse-euroderm.de" className="header-contact-link">
                  info@hanse-euroderm.de
                </a>
              </div>
              <MenuModal/>
              <div className='languages-right'>
                <Languages color={logoColor}/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
